<style>
#watermetersRegisterModal .v--modal-box.v--modal {
  min-height: 440px !important;
  min-width: 620px !important;
}
#watermetersRegisterModal .modal__footer {
  display: none;
}
#watermetersRegisterModal .modal__content {
  margin-top: -50px;
}
</style>

<template>
  <Modal
    modalName="watermetersRegisterModal"
    title="REJESTR WODOMIERZY"
    :buttons="[]"
    :register="register"
  >
    <WatermetersTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import WatermetersTable from "../../table/WatermetersTable";

export default {
  components: {
    Modal,
    WatermetersTable
  },
  data: () => ({
    register: true
  })
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/watermeters/modals/WatermetersRegister.vue